// @flow
import React from 'react';

import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import List, { ListItem } from 'material-ui/List';

import { getFeatureColor } from 'utils/mapStyle';
import { AIRSPACE_TYPE_LABELS, AIRSPACE_USE_TYPES } from 'utils/propSheet';

const styles = {
  container: {
    padding: 16,
  },
};

const renderAvatarIcon = as =>
  as.use_type in AIRSPACE_USE_TYPES ? (
    AIRSPACE_USE_TYPES[as.use_type].icon
  ) : (
    <FontIcon className="material-icons" size={12}>
      flight
    </FontIcon>
  );

export default ({
  search: {
    availability_result: { overlapping_airspaces: airspaces },
  },

  pushRoute,
  toggleSearchResultsDialog,
}) => (
  <div style={styles.container}>
    <p>
      {airspaces.length > 0
        ? 'Az ön által megadott terület az adott időpontban az alábbi légterekkel lapol át:'
        : 'A megadott koordináták az adott időpontban nem lapolnak át egyetlen légtérrel sem.'}
    </p>
    <List style={{ marginBottom: 40 }}>
      {airspaces.map(as => (
        <ListItem
          key={`as-${as.slug}`}
          primaryText={as.name}
          secondaryText={AIRSPACE_TYPE_LABELS[as.airspace_type]}
          leftAvatar={
            <Avatar
              style={{ backgroundColor: getFeatureColor(as) }}
              color="white"
              icon={renderAvatarIcon(as)}
            />
          }
          onClick={() => {
            pushRoute(`/as/${as.slug}`, { pan: true });
            toggleSearchResultsDialog(false);
          }}
        />
      ))}
    </List>
  </div>
);



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/OverlappingAirspacesList.js